import React from "react";
import "../styles/Careers.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import UseSEO from "../../Hooks/useSEO";


const Careers = () => {

     // Use the hook at the top of the component suport in React 19
    UseSEO({
        title: "Sujaramaha Enterprises | Our Careers",
        description:
            "Computer & Printers, Insurance, CCTV Solutions, Solar, Water Filter, Inverter, Battary",
        keywords: "insurance, CCTV, computer service, Sujaramaha Enterprises"
    });

    return (
        <div className="careers-page">

            {/* Hero */}
            <section className="careers-hero">
                <div className="careers-hero-overlay">
                    <h1>Our Careers</h1>
                    <p>
                        Comprehensive Insurance, Technology & Security Solutions
                        under one trusted brand - Sujaramaha Enterprises
                    </p>
                </div>
            </section>

            {/* careers Grid */}
            <section className="Careers-container">
                <h2>Coming Soon.....</h2>

                
            </section>

            {/* CTA */}
            <section className="careers-cta">
                <h2>Need Expert Assistance?</h2>
                <p>
                    Contact Sujaramaha Enterprises today for trusted careers,
                    professional support, and reliable solutions tailored to your needs.
                </p>
                <a href="/contact">Contact Us</a>
            </section>

        </div>
    );
};

export default Careers;